import { useSnackbar } from '@/features/snackbar';
import { useFlag } from '@/features/unleash';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { useLocale } from '@/hooks/useLocale';
import routesGenerator from '@/router/routesGenerator';
import { isSupportedLocale } from '@/utils/locale';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { pathToAction, redirect } from 'redux-first-router';
import { useTracking } from 'react-tracking';

export function SupportedLocaleDetector() {
  const locale = useLocale();
  const { addSnackbar } = useSnackbar();
  const url = useCompanyCanonicalUrl();
  const dispatch = useDispatch();

  const { enabled } = useFlag({ name: 'supported-locale-detector' });

  const routesMap = useMemo(() => routesGenerator(), []);

  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'supported-locale-detector',
  });

  useEffect(() => {
    /**
     * @todo: will need to convert to a hook when reading the system language. This is
     * only applicable to web. Native will have different method of getting system language.
     */
    const systemLanguage = navigator.language;
    const languagePart = systemLanguage.split('-')[0];
    if (enabled && isSupportedLocale(languagePart) && locale !== languagePart) {
      addSnackbar({
        id: 'locale-available',
        message: 'This report is available in your preferred language setting.',
        actionLabel: 'View',
        async actionCallback() {
          trackEvent({
            action: 'click',
            modifier: 'preferredLanguage',
            locale: languagePart,
          });
          const action = pathToAction(`/${languagePart}${url}`, routesMap);
          dispatch(action);
        },
        secondaryActionLabel: 'Dismiss',
      });
    }
    /**
     * note: do not include `addSnackbar` in the dependency as it causes infinite renders.
     * maybe `addSnackbar` is not a stable reference.
     */
  }, [locale, enabled, url, dispatch, redirect, trackEvent]);
  return <></>;
}
